import { faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Grid, TableCell, TableRow, Typography } from "@mui/material";
import AppointmentApi from "api/counter/appointment.api";
import IconNewEdit from 'assets/icon/newEdit';
import { notiError } from "component/notifications/notifications";
import TableCustom from "component/Table/TableCustom";
import { icons } from "constants/images";
import { colors, ThemeIcon } from "constants/theme";
import _ from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { numberToCurrencyFormat, toBuddhistYear } from "utils/app.utils";
import { dateTimeToView } from "utils/date.utils";
import { StatusSelectorCustom } from './follow-up';
interface AppointmentHistoryTableProps {
    patientId: number
}

export default function AppointmentHistoryTable(props: AppointmentHistoryTableProps) {
    const { t, i18n } = useTranslation()
    const [appointmentHistory, setAppointmentHistory] = useState([])
    const [page, setPage] = useState(1)
    const [pageLimit, setPageLimit] = useState(5)
    const [rowCount, setRowCount] = useState(0)

    const loadData = async () => {
        try {
            await AppointmentApi.findAllHistory({ page: page, pageLimit: pageLimit, patientId: props.patientId, sortBy: 'date', sortType: "DESC" }).then((resp) => {
                setAppointmentHistory(resp.data)
                setRowCount(resp.headers['x-total'])
            })
        } catch (error) {
            notiError(t('ERROR'))
        }
    }

    useEffect(() => {
        loadData()
    }, [page, pageLimit])

    const headCells = [
        { id: 'no', disablePadding: false, label: 'ลำดับ' },
        { id: 'detail', disablePadding: false, label: 'รายละเอียด' },
        { id: 'action', disablePadding: false, label: 'จัดการ' },
    ]
    const statusIcon: any = {
        NORMAL: { icon: <FontAwesomeIcon style={{ color: colors.white }} icon={faUser} />, color: colors.appointmentStatus.statusNormal, statusName: t('APPOINTMENT.STATUS.NORMAL'), disabled: false },
        CANCEL_APP: { icon: <img alt="" style={{ height: '15px' }} src={icons.appointment.cancel_app} />, color: colors.appointmentStatus.statusCancel, statusName: t('APPOINTMENT.STATUS.CANCEL'), disabled: false },
        CANCEL: { icon: <img alt="" style={{ height: '15px' }} src={icons.appointment.iconCancel} />, color: colors.appointmentStatus.statusCancel, statusName: t('APPOINTMENT.STATUS.CANCEL'), disabled: false },
        CAN_NOT_CONTACT: { icon: <img alt="" style={{ height: '15px' }} src={icons.appointment.iconNotConnect} />, color: colors.appointmentStatus.statusUnConnect, statusName: t('APPOINTMENT.STATUS.CAN_NOT_CONTACT'), disabled: false },
        PUT_OFF: { icon: <img alt="" style={{ height: '15px' }} src={icons.appointment.iconChangeSchedule} />, color: colors.appointmentStatus.statusChange, statusName: t('APPOINTMENT.STATUS.PUT_OFF'), disabled: false },
        CONFIRM: { icon: <img alt="" style={{ height: '15px' }} src={icons.appointment.iconEnter} />, color: colors.appointmentStatus.statusEnter, statusName: t('APPOINTMENT.STATUS.CONFIRM'), disabled: false },
        ARRIVED: { icon: <img alt="" style={{ height: '15px' }} src={icons.appointment.iconUserCheckTrue} />, color: colors.appointmentStatus.statusArrived, statusName: t('APPOINTMENT.STATUS.ARRIVED'), disabled: false },
        NOT_YET: { icon: <img alt="" style={{ height: '15px' }} src={icons.appointment.iconUserCheckFalse} />, color: colors.appointmentStatus.statusUnArrived, statusName: t('APPOINTMENT.STATUS.NOT_YET'), disabled: false },
        PAYMENT: { icon: <img alt="" style={{ height: '15px' }} src={icons.appointment.iconPendingPayment} />, color: colors.appointmentStatus.statusWaitPayment, statusName: t('APPOINTMENT.STATUS.PENDING_PAYMENT'), disabled: true },
        PENDING_PAYMENT: { icon: <img alt="" style={{ height: '15px' }} src={icons.appointment.iconWaitPayment} />, color: colors.appointmentStatus.statusPayment, statusName: t('APPOINTMENT.STATUS.PAYMENT'), disabled: true },
        PENDING_SERVICE: { icon: <img alt="" style={{ height: '15px' }} src={icons.appointment.iconCounterCheckIn} />, color: colors.appointmentStatus.statusCounterCheckIn, statusName: t('APPOINTMENT.STATUS.PENDING_SERVICE'), disabled: true },
        SERVICE: { icon: <img alt="" style={{ height: '17px' }} src={icons.appointment.iconService} />, color: colors.appointmentStatus.statusService, statusName: t('APPOINTMENT.STATUS.SERVICE'), disabled: true },
        DONE: { icon: <img alt="" style={{ height: '15px' }} src={ThemeIcon.DoneTreatment} />, color: colors.appointmentStatus.statusDone, statusName: t('APPOINTMENT.STATUS.DONE'), disabled: true },
    }

    const renderData = (objData: any, no: number) => {
        const index = page * pageLimit - pageLimit + no + 1
        return (
            <>
                <TableRow>
                    <TableCell align="center" scope="row">
                        <Typography>{index}</Typography>
                    </TableCell>
                    <TableCell align="left" scope="row">
                        <Grid container>
                            <Grid xs={3}> <Typography>สาขา</Typography></Grid>
                            <Grid xs={9}><Typography>{objData?.branchName}</Typography></Grid>
                            <Grid xs={3}> <Typography>วันที่นัด</Typography></Grid>
                            <Grid xs={9}><Typography>{toBuddhistYear(moment(objData?.date), 'DD/MM/YYYY')}</Typography></Grid>
                            <Grid xs={3}> <Typography>เวลาเริ่มต้น</Typography></Grid>
                            <Grid xs={9}><Typography>{`${objData?.timeStart.replace(':00', '').replace(':', '.')} ${t('TIME_UNIT')}`}</Typography></Grid>
                            <Grid xs={3}> <Typography>ทันตแพทย์</Typography></Grid>
                            <Grid xs={9}><Typography>{objData?.doctorFullname}</Typography></Grid>
                            <Grid xs={3}> <Typography>รายการรักษา</Typography></Grid>
                            <Grid xs={9}><Typography>{String(_.map(objData?.appointmentOperatives, (op: any) => op.operativeName || op.operativeTypeName).join(', '))}</Typography></Grid>
                            <Grid xs={3}> <Typography>สถานะ</Typography></Grid>
                            <Grid xs={9}>
                                <StatusSelectorCustom
                                    optionPatientStatuses={statusIcon}
                                    status={objData?.statusAppointment}
                                    unshow
                                />
                            </Grid>
                            <Grid xs={3}> <Typography>ประเมินราคา</Typography></Grid>
                            <Grid xs={9}><Typography>{numberToCurrencyFormat(objData?.price)}</Typography></Grid>
                            <Grid xs={3}> <Typography>การปฏิบัติ</Typography></Grid>
                            <Grid xs={9} sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}><Typography>{objData?.practice || '-'}</Typography></Grid>
                            <Grid xs={3}> <Typography>หมายเหตุ</Typography></Grid>
                            <Grid xs={9} sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}><Typography>{objData?.remark || '-'}</Typography></Grid>
                            <Grid xs={3}> <Typography>LAB</Typography></Grid>
                            <Grid xs={9}><Typography>{t(`${objData?.hasLab}`)}</Typography></Grid>
                            <Grid xs={3}> <Typography>X-Ray</Typography></Grid>
                            <Grid xs={9}><Typography>{t(`${objData?.hasXray}`)}</Typography></Grid>
                            <Grid xs={3}> <Typography>ผู้สร้าง</Typography></Grid>
                            <Grid xs={9}>
                                <Box display="flex" flexDirection="row" alignItems="center" gap="8px">
                                    <Typography>{objData?.createdBy}</Typography>
                                    <Typography fontSize={14}>{dateTimeToView(objData?.createdAt)}</Typography>
                                </Box>
                            </Grid>
                            <Grid xs={3}> <Typography>ผู้บันทึกล่าสุด</Typography></Grid>
                            <Grid xs={9}>
                                <Box display="flex" flexDirection="row" alignItems="center" gap="8px">
                                    <Typography>{objData?.updatedBy}</Typography>
                                    <Typography fontSize={14}>{dateTimeToView(objData?.updatedAt)}</Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </TableCell>
                    <TableCell align="center" scope="row">
                        <Box sx={{ cursor: 'pointer' }}
                            onClick={() => {
                                window.open(`/appointment?appointmentId=${objData?.appointmentId}&doctorId=${objData?.doctorId}&branchId=${objData?.branchId}&date=${objData?.date}`, '_blank')
                            }}>
                            <IconNewEdit width="24px" height="24px" />
                        </Box>
                    </TableCell>
                </TableRow>
            </>
        )
    }

    return (
        <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={'DESC'}
            sortBy={'date'}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={_.map(appointmentHistory, (topic, index: number) => {
                return renderData(topic, index)
            })}
            textEmptyData={t('ยังไม่มีข้อมูล')}
            onSort={() => {
                return
            }}
            setPageLimit={(e) => setPageLimit(e)}
            setPage={(e) => setPage(e)}
            maxHeight={500}
            overflowY="auto"
        />
    )
}